/**
 * Design system icon size tokens.
 * Values align with --icon-* CSS custom properties in global.css.
 */
export const IconSize = {
    xs: 10, // --icon-xs: compact chip/badge controls
    sm: 14, // --icon-sm: inline metadata, chip labels
    md: 16, // --icon-md: buttons, menu items, controls
    lg: 18, // --icon-lg: nav rail icons
    xl: 24, // --icon-xl: large display icons
};
//# sourceMappingURL=tokens.js.map